import React, { useEffect } from "react";
import GridItem from "../../../../Components/UiComponents/GridItem/GridItem";
import { GridStack } from "gridstack";
import DMSHeader from "../../DMSHeader/DMSHeader";
import { useTranslation } from "react-i18next";
import AffectedReportTable from "./AffectedReportTable/AffectedReportTable";

const AffectedReport = () => {
  return (
    <div>
      <div className="widget-container">
        <DMSHeader title="Affected Report - Bihar State" />
      </div>
      <div className="widget-container p-1">
        <AffectedReportTable />
      </div>
    </div>
  );
};

export default AffectedReport;
